<template>
	<p class="deco_underline"></p>
</template>

<script>
	export default {};
</script>

<style></style>
